import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class ProductOutOfStock extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateField);
    closestSection?.addEventListener(ThemeEvents.variantSelected, this.#onVariantSelected);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateField);
    closestSection?.removeEventListener(ThemeEvents.variantSelected, this.#onVariantSelected);
  }

  #onVariantSelected = () => this.setAttribute('shimmer', '');

  /**
   * Updates the field.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateField = async (event) => {
    const section = this.closest('.shopify-section, dialog');
    await section?._inventoryReady;

    this.removeAttribute('shimmer');

    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newField = event.detail.data.html.querySelector('product-out-of-stock');

    if (!newField) return;

    morph(this, newField, { childrenOnly: true });
  };
}

if (!customElements.get('product-out-of-stock')) {
  customElements.define('product-out-of-stock', ProductOutOfStock);
}
